export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10020.deee710a.jpg";